export const SpaceLabelsService = Symbol.for('SpaceLabelsService');
